module.exports = __webpack_public_path__ + "resources/icon_50_selected.5db07c15cac639d6.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_50_selected.png
// module id = 459
// module chunks = 0 1 2 3 4